<template>
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <Row>
        <Col :md="24" style="margin-bottom: 20px">
          <Button
            type="primary"
            icon="md-add"
            style="margin-right: 8px"
            @click="createItem"
            >新增分类</Button
          >
        </Col>
      </Row>
      <Table
        :columns="queryColumn"
        :loading="loading"
        :data="queryData"
        border
        ref="dataTable"
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="text"
            class="text-link"
            size="small"
            icon="md-create"
            @click="updateItem(row, index)"
            >编辑</Button
          >
          <Button
            type="text"
            class="text-link"
            size="small"
            icon="md-trash"
            @click="deleteItem(row)"
            >删除</Button
          >
        </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page
            :total="totalPage"
            :page-size="pageSize"
            :current="pageNum"
            :disabled="loading"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-elevator
            show-sizer
            show-total
          />
        </Col>
      </Row>
    </Content>
    <CategoryCreateUpdate
      ref="categoryCreateUpdate"
      @success="createUpdateSuccess"
    />
  </div>
</template>

<script>
import utils from '../../utils'
import api from '../../api'
import CategoryCreateUpdate from '../../components/commodity/CategoryCreateUpdate'

export default {
  components: {
    CategoryCreateUpdate
  },
  data () {
    return {
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1
    }
  },
  computed: {
    queryColumn () {
      return [
        {
          title: '分类编号',
          key: 'id',
          align: 'center',
          minWidth: 150
        },
        {
          title: '分类名称',
          key: 'labelName',
          align: 'center',
          minWidth: 150
        },
        {
          title: '创建时间',
          key: 'createDate',
          align: 'center',
          minWidth: 190,
          render: (h, params) => {
            return h('span', utils.formatDateTime(params.row.createDate))
          }
        },
        {
          title: '备注',
          key: 'remark',
          align: 'center',
          minWidth: 190
        },
        {
          title: '操作',
          key: 'id',
          minWidth: 150,
          slot: 'action',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    getData () {
      this.loading = true
      api.commodity
        .categoryList({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取商品分类列表失败: ' + err.message)
        })
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
    },
    // 新增
    createItem () {
      this.$refs.categoryCreateUpdate.show('create')
    },
    // 编辑
    updateItem (row, index) {
      this.$refs.categoryCreateUpdate.show('update', row, index)
    },
    // 删除
    deleteItem (row) {
      let timer = null
      this.$Modal.confirm({
        title: '删除确认',
        content: `<p>您确定删除此分类吗？</p>
                  <p><small class="text-danger">注：如果此分类有商品，则无法删除。</small></p>`,
        loading: true,
        onOk: () => {
          api.commodity
            .categoryDelete({
              labelId: row.id
            })
            .then(() => {
              this.$Modal.remove()
              if (!(this.queryData.length - 1)) {
                this.pageNum = this.pageNum - 1 ? this.pageNum - 1 : 1
              }
              this.getData()
              this.updateStoreCategory()
              this.$Message.success('删除成功!')
            })
            .catch((err) => {
              this.$Modal.remove()
              timer = setTimeout(() => {
                this.$Modal.error({
                  title: '抱歉',
                  content: '删除失败: ' + err.message,
                  onOk: () => {
                    clearTimeout(timer)
                  }
                })
              }, 500)
            })
        }
      })
    },
    // 新增，编辑成功
    createUpdateSuccess () {
      this.getData()
      this.updateStoreCategory()
    },
    // 更新store commodityCategory
    updateStoreCategory () {
      this.$store.dispatch('commodity/getCommodityCategory')
    }
  },
  created () {
    this.getData()
  }
}
</script>
